const getElementTitle = (elementName: string, index: number): string =>
  `${index + 1}. ${elementName}`;

export default getElementTitle;
